import React, { useState, useEffect } from "react";
import { Button, Container, Form } from "react-bootstrap";
import {
  findUserByEmailInOldDB,
  getUsersByFilterDate,
  getUsersByFilterDateOldDB,
} from "../../api/apiAdmin";
import { getDataClientByEmailInDB } from "../../api/apiNewUser";
import { formatDate2, myId } from "../../lib/MyLibrary";
import MyModal from "./MyModal";
import ExportJsonExcel from "js-export-excel";
import Spinner from "react-bootstrap/Spinner";
//import { set } from "mongoose";

const initialConsult = {
  emailUser: "",
  startDate: "",
  endDate: "",
};

const Consulta = () => {
  const [consult, setConsult] = useState(initialConsult);
  const [isValidConsult, setIsValidConsult] = useState(false);
  const [arrayUsers, setArrayUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [targetEmail, setTargetEmail] = useState("");
  const [noData, setNoData] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [tableUsers, setTableUsers] = useState(true);

  const handleModal = () => {
    setShowModal((prev) => !prev);
  };

  const handleChange = (e) => {
    //console.log(e.target.name,e.target.value);
    setConsult({
      ...consult,
      [e.target.name]: e.target.value,
    });
  };

  const handleConsultaOld = async (e) => {
    e.preventDefault();
    console.log("Datos de Consulta:..", consult);

    if (consult.emailUser || consult.startDate) {
      console.log("Consulta Valida...");
      //setShowSpinner(true);
      if (consult.emailUser) {
        const result = await findUserByEmailInOldDB(consult.emailUser);
        console.log("Result findUserByEmailInOldDB:..", result);
        //response.data.result[0]
        if (result) {
          const dataUser = result.response?.data?.result[0];
          if (dataUser) {
            const tempArray = [];
            tempArray.push(dataUser);
            setArrayUsers([...tempArray]);
          }
        }
      }
      if (consult.startDate&&!consult.emailUser) {
        await getDataByFilterDate();
      }
    } else {
      console.log("Consulta NO Valida...");
    }
  };

  const handleConsulta = async (e) => {
    e.preventDefault();
    console.log("Datos de Consulta:..", consult);
    if (consult.emailUser || consult.startDate) {
      console.log("Consulta Valida...");
      setShowSpinner(true);
      if (consult.startDate) {
        await getDataByFilterDate();
      }
      if (!consult.startDate && consult.emailUser) {
        const resultTemp = await getDataClientByEmailInDB(consult.emailUser);
        console.log("ResultTemp:..", resultTemp);
        if (resultTemp) {
          const dataArray = []; //resultTemp.data?.result;
          if (!resultTemp.data?.result) {
            console.log("No Data Founded:..");
            setNoData(true);
          } else {
            setNoData(false);
            dataArray.push(resultTemp.data?.result);
          }
          setArrayUsers(dataArray);
        }
      }
    } else {
      console.log("Consulta NO Valida...");
    }
    setShowSpinner(false);
  };
  const getDataByFilterDate = async () => {
    const today = new Date();
    const formatToday = formatDate2(today);
    if (!consult.endDate) console.log("formatToday:..", formatToday);
    const dateScope = {
      startDate: consult.startDate,
      endDate: consult.endDate || formatToday,
    };
    try {
      setShowSpinner(true);
      let result = null;
      if (tableUsers) {
        result = await getUsersByFilterDate(dateScope);
      } else {
        result = await getUsersByFilterDateOldDB(dateScope);
      }

      console.log(result);
      if (result) {
        setShowSpinner(false);
        console.log("DataUsers:..", result.response?.data?.usersFilter); //response.data.usersFilter
        const tempArray = result.response?.data?.usersFilter;
        if (!consult.emailUser) {
          setNoData(false);
          setArrayUsers(tempArray);
        } else {
          setNoData(false);
          const secondArray = tempArray.filter(
            (item) => item.email === consult.emailUser
          );
          setArrayUsers(secondArray);
          if (secondArray.length === 0) setNoData(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDetalles = (e) => {
    console.log("Detalles de:..", e.target.name);
    setTargetEmail(e.target.name);
    handleModal();
  };
  const exportConsult = () => {
    console.log("Exportaremos la consulta:..", arrayUsers);
    //setShowSpinner(true);
    let columnWidthsArray = [];
    let keysLength = Object.keys(arrayUsers[0]).length;

    for (let i = 0; i <= keysLength; i++) {
      columnWidthsArray.push(15);
    }

    let option = {};

    option.fileName = "consultaUsers";

    option.datas = [
      {
        sheetData: [...arrayUsers],
        sheetName: "consulta1",
        sheetFilter: Object.keys(arrayUsers[0]),
        sheetHeader: Object.keys(arrayUsers[0]),
        columnWidths: [...columnWidthsArray],
      },
    ];

    let toExcel = new ExportJsonExcel(option); //new
    toExcel.saveExcel(); //guardando
    console.log("Ya deberia de existir el archivo:..", toExcel);
  };

  const handleChangeTable = () => {
    setTableUsers((prev) => !prev);
  };
  return (
    <div>
      <Form className="row ms-auto me-auto">
        <Form.Group
          className="d-flex justify-content-center align-items-center my-3 fs-5"
          controlId="formBasicTypeConsult"
        >
          <Form.Check
            className="me-3"
            value="new"
            name="tableUsers"
            checked={tableUsers ? true : false}
            onChange={handleChangeTable}
            type="radio"
            label="newDB"
          />
          <Form.Check
            value="old"
            name="tableUsers"
            checked={!tableUsers ? true : false}
            onChange={handleChangeTable}
            type="radio"
            label="oldDB"
          />
        </Form.Group>

        <Form.Group
          className="mb-3 col-11 col-md-4 col-lg-3"
          controlId="formBasicStartDate"
        >
          <Form.Label className="fw-bold">Inicio:</Form.Label>
          <Form.Control
            value={consult.startDate}
            name="startDate"
            onChange={handleChange}
            type="date"
          />
          <Form.Text className="text-muted">
            Fecha de Inicio de la Busqueda.
          </Form.Text>
        </Form.Group>
        <Form.Group
          className="mb-3 col-11 col-md-4 col-lg-3"
          controlId="formBasicStartDate"
        >
          <Form.Label className="fw-bold">Fin:</Form.Label>
          <Form.Control
            value={consult.endDate}
            name="endDate"
            onChange={handleChange}
            type="date"
          />
          <Form.Text className="text-muted">
            Fecha de Fin de la Busqueda.
          </Form.Text>
        </Form.Group>
        <Form.Group
          className="mb-3 col-11 col-md-11 col-lg-5"
          controlId="formBasicEmail"
        >
          <Form.Label className="fw-bold">Ingresar Email</Form.Label>
          <Form.Control
            value={consult.emailUser}
            name="emailUser"
            onChange={handleChange}
            type="email"
            placeholder="email"
          />
          <Form.Text className="text-muted">
            Introducir el email del usuario a consultar.
          </Form.Text>
        </Form.Group>
        {arrayUsers.length > 0 && (
          <div className="d-flex align-items-center">
            <Button style={{ width: "fit-content" }} onClick={exportConsult}>
              Exportar Consulta
            </Button>

            <h6 className="ms-3">{arrayUsers.length}: user(s)</h6>
          </div>
        )}

        <Button
          onClick={tableUsers ? handleConsulta : handleConsultaOld}
          style={{ width: "fit-content" }}
          className="ms-auto me-2"
        >
          Realizar Consulta
        </Button>
      </Form>
      {showSpinner && <Spinner className="d-block ms-auto me-auto" />}
      {arrayUsers.length > 0 && (
        <div className="mt-3">
          <div className="row text-dark bg-secondary">
            <h6 className="col-12 col-md-6">Nombre:</h6>
            <h6 className="col-12 col-md-6">Email:</h6>
          </div>
          {arrayUsers.map((user, index) => {
            return (
              <div key={myId()} className="mt-0 mb-0 rounded border border-2">
                <div
                  style={{
                    backgroundColor: (index + 1) % 2 === 0 ? "#ddd" : "#fff",
                  }}
                  className="row"
                >
                  <h6 className="col-12 col-md-5 text-primary ms-2">{`${
                    tableUsers ? user.nameUser : user.firstName
                  } ${tableUsers ? user.paterno : user.lastName} ${
                    tableUsers ? user.materno : ""
                  }`}</h6>
                  <h6 className="col-12 col-md-5 text-secondary">
                    {user.email}
                  </h6>
                  <button
                    className="col-2 col-md-1 btn btn-outline-primary"
                    name={user.email}
                    onClick={handleDetalles}
                  >
                    🔍
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {noData && <h3 className="text-danger text-center">No Data Client...</h3>}
      {showModal && (
        <MyModal
          showModal={showModal}
          handleModal={handleModal}
          emailUser={targetEmail}
          tableUsers={tableUsers}
        />
      )}
    </div>
  );
};

export default Consulta;
